<div class="copy-config-from-item-wrapper">

  <div class="title_close">
    <h3 class="copy-config-from-title">
      {{ 'sources.configuration.copyConfigFrom' | translate | uppercase }}
    </h3>

    <i class="material-icons close-icon" (click)="onCloseModal()">
      close
    </i>
  </div>


  <div class="name-of-datasource">
    <i class="material-icons" (click)="onBackToChooseDs()">
      keyboard_arrow_left
    </i>
    <span>{{ dialogData.sourceDS.Slug | uppercase }}</span>
  </div>


  <div class="configuration-place">
    <div class="block-wrapper">
      <div class="configuration-list-place" #tableHolder>
        <ng-template #recursiveList let-context>

          <ng-container *ngFor="let node of context.list">
            <tr *ngIf="showNode(node)"
                class="table-row"
                (click)="activateNode(node.node)"
                (mouseenter)="hoveredItemId = node.Id"
                (mouseleave)="hoveredItemId = null"
                [class.hover]="hoveredItemId === node.Id"
                [class.active]="activatedNode && activatedNode.Id === node.Id && !activatedNode.isRoot"
                [class.changed]="node.changed">
              <td *ngFor="let row of context.rows" [ngSwitch]="row.key"
                  [ngClass]="row.className"
                  [style.padding-left]="context.fixed ? node.level * 10 + 'px' : null"
                  [style.border-color]="row.key === 'MainColor' || row.key === 'SecondColor' ? node[row.key] : null"
                  [class]="'row-' + row.key"
                  [class.leaf]="node.isLeaf || node.isSubtype"
                  [class.has-children]="node.hasChildren">

                <!--LayerName Column-->

                <div *ngIf="context.fixed"
                     [ngStyle]="{ 'opacity' : node.node.IsExcludedFromProcessing ? '0.4' : '1' }"
                     class="layerName-place">
                  <ng-container
                    *ngIf="node.hasChildren">
                    <mat-icon class="arrow-icon" *ngIf="!node.expanded" (click)="expandNode($event, node)">
                      keyboard_arrow_right
                    </mat-icon>
                    <mat-icon class="arrow-icon" *ngIf="node.expanded" (click)="collapseNode($event, node)">
                      keyboard_arrow_down
                    </mat-icon>
                    <mat-icon
                      *ngIf="node.isBranch"
                      class="folder-icon">folder
                    </mat-icon>
                  </ng-container>
                  <ng-container
                    *ngIf="node.isLeaf || node.isSubtype"
                    [ngSwitch]="node.node.ObjectType">
                    <img src="/assets/img/icons/unknown.svg" class="type-icon" *ngSwitchCase="ObjectType.UNKNOWN"
                         alt=""/>
                    <img src="/assets/img/icons/point.svg" class="type-icon" *ngSwitchCase="ObjectType.POINT" alt=""/>
                    <img src="/assets/img/icons/line.svg" class="type-icon" *ngSwitchCase="ObjectType.LINE" alt=""/>
                    <img src="/assets/img/icons/area.svg" class="type-icon" *ngSwitchCase="ObjectType.AREA" alt=""/>
                    <img src="/assets/img/icons/3d.svg" class="type-icon" *ngSwitchCase="ObjectType.MODEL3D" alt=""/>
                    <mat-icon *ngSwitchDefault class="type-icon">help_outline</mat-icon>
                  </ng-container>

                  <div class="additional-info">
                    <span *ngSwitchCase="'LayerName'"
                          class="layer-name"
                          [matTooltip]="node[row.key] && node[row.key].length > 11 ? node[row.key] : ''"
                          [ngClass]="{subtype: node.isSubtype}">
                      {{node[row.key]}}
                      <ng-container *ngIf="node.isSubtype && node.DisplayName">({{node.DisplayName}})</ng-container>
                    </span>

                    <div class="copy-feature-layer" *ngIf="!isCopyDSToDS">
                      <span
                        *ngIf="!node.isBranch && !node.isSubtype"
                        class="object-type">
                        {{ getObjectTypeName(node.node.ObjectType) }}
                      </span>

                      <span class="object-subtype">
                        {{ getObjectSubtypeName(node, node.node.ObjectSubType) }}
                      </span>
                    </div>

                    <!--TODO fix bug with image when configuratin layer chosen-->

                    <div class="copy-ds" *ngIf="isCopyDSToDS && !node.isRoot && node.node.possibleLayersForConfig">
                      <mat-form-field class="alternative-feature-layer">
                        <mat-select
                          [value]="node.node.firstAlternativeLayer"
                          (selectionChange)="onChangeAlternativeLayer($event, node)"
                        >
                          <mat-select-trigger>
                            <span
                              class="default-image"
                              [innerHtml]="getObjectTypeImage(node.node.firstAlternativeLayer.ObjectType)">
                            </span>

                            <span>{{ node.node.firstAlternativeLayer.LayerName }}</span>
                          </mat-select-trigger>

                          <mat-option
                            *ngFor="let option of node.node.possibleLayersForConfig"
                            [value]="option">
                           <span
                             class="default-image"
                             style="margin-left: 0; vertical-align: middle"
                             [innerHtml]="getObjectTypeImage(option.ObjectType)">
                            </span>


                            <span [matTooltip]="option.LayerName">
                              {{ option.LayerName }}
                            </span>
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>


                  </div>
                </div>
                <!--End LayerName Column-->
              </td>
            </tr>
          </ng-container>
        </ng-template>


        <ng-template #tableTemplate let-context>
          <table class="table table-condensed" matSort
                 [class.table-bordered]="context.fixed"
                 [class.table-fixed]="context.fixed"
                 [class.table-scrollable]="!context.fixed">
            <thead>

            <!--ObjectType Groups-->
            <tr *ngIf="!context.fixed" class="group-titles">
              <th colspan="17">{{ 'configurations-fields.columnsGroupNames.global' | translate }}</th>
              <th colspan="5">{{ 'configurations-fields.columnsGroupNames.linePipeWire' | translate }}</th>
              <th colspan="5">{{ 'configurations-fields.columnsGroupNames.line' | translate }}</th>
              <th colspan="9">{{ 'configurations-fields.columnsGroupNames.pointManholeInlet' | translate }}</th>
              <th colspan="10">{{ 'configurations-fields.columnsGroupNames.pointObject' | translate }}</th>
              <th>{{ 'configurations-fields.columnsGroupNames.pointCustom' | translate }}</th>
            </tr>
            <!--END ObjectType Groups-->
            </thead>
            <tbody>
            <ng-container
              [ngTemplateOutlet]="recursiveList"
              [ngTemplateOutletContext]="{
                $implicit: {
                  rows: context.rows,
                  list: context.list,
                  fixed: context.fixed
                }
              }">
            </ng-container>
            </tbody>
          </table>
        </ng-template>


        <div class="table-group">
          <div class="fixed-table-place">
            <ng-container
              #fixedContainer
              [ngTemplateOutlet]="tableTemplate"
              [ngTemplateOutletContext]="{
                $implicit: {
                  fixed: true,
                  rows: fixedRows,
                  list: orderableList
                }
              }">
            </ng-container>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="copy-button">
    <button
      mat-raised-button
      [disabled]="isCopyButtonDisabled()"
      [class.disabled]="isCopyButtonDisabled()"
      (click)="onCopyConfig()">
      {{ 'sources.configuration.copy' | translate }}
    </button>
  </div>

</div>

